import React,{ useState } from 'react'
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Box, Button, FormControlLabel, IconButton, Switch, TextField } from '@mui/material';
// import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteIcon from '@mui/icons-material/Delete';
import { MuiTelInput } from 'mui-tel-input';
// import { useCreateCardDetailContext } from '../../../CreatecardDetailContext';
import { ReactComponent as EditIcon } from "../../Assets/img/icons/Edit Pencil.svg"
import PropTypes from 'prop-types';
import { PhoneInputMenuProps } from '../Onboarding/ActiveStep4';
import { socialLinksSections } from '../Utilities/SocialMediaMapping';

const AccordionItem = ({ 
    network, 
    icon: Icon, 
    iconColor,
    label,
    visible, 
    input,
    toggleVisibility,
    onUpdate, 
    onDelete,
    defaultOpen, 
    inputType,
    handleResendOTP,
    isUpdateButtonEnabled 
  }) => {

    const [expanded, setExpanded] = useState(defaultOpen);

    const paymentsObject = socialLinksSections.find(section => section.title === "Payment");
    const paymentsLinks = paymentsObject?.links || []; // Ensure it's not undefined

    const customLabels = ["website", "ownportfolio"];

    const handleCancel = () => {
        setExpanded(false);
    }

    const handleUpdate = () => {
      if(inputType === 'text')
        setExpanded(false);
      else {
        handleResendOTP();
        setExpanded(false);
      }
    }

    const renderInputField = () => {
      if (inputType === 'phone') {
        return (
          <MuiTelInput
            name={network}
            value={input}
            onChange={(value) => onUpdate(value)}
            defaultCountry={'in'}
            MenuProps={PhoneInputMenuProps}
            required
            className={`text-field-outline input-text ${!input ? "input-error" : ""}`}
          />
        );
      }
      else if(inputType === 'email') {
        return (
        <TextField
          label="E-mail ID"
          fullWidth
          value={input}
          onChange={(value) => onUpdate(value)}
        />
        );
      }
      else if(paymentsLinks.some(link => link.network === network)) {
        return (
        <TextField
          label="Payment ID"
          fullWidth
          value={input}
          onChange={(value) => onUpdate(value)}
        />
        );
      }
      else if(customLabels.includes(network)) {
        return (
        <TextField
          label="Custom Domain or URL"
          fullWidth
          value={input}
          onChange={(event) => onUpdate(network, 'url')(event)}
        />
        );
      }
      else {
      return (
        <TextField
          label="Account Username"
          fullWidth
          value={input}
          onChange={(event) => onUpdate(network, 'url')(event)}
        />
      );
      }
    };
  
    return (
      <Accordion
        defaultExpanded={defaultOpen}
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
        className="custom-accordion-root mb-3"
        sx={{ border: "1px solid #D9D9D9", borderRadius: 1 }}
      >
        <AccordionSummary>
          <div className="contact-item-left d-flex flex-row align-items-center">
            {/* <DragIndicatorIcon /> Commented until Drag and order functionality pending */} 
            {(inputType === 'phone' || inputType === 'email') ? (
            <div className='icon icon-outside mx-2 flex-center contact-icon-shadow' style={{backgroundColor: iconColor}}>
              <Icon className='icon-color3' />
            </div>
            ) : (
            <div className="icon mx-2 flex-center">
              <Icon className="icon-color3 social-icon" />
            </div>
          )}
            <div>{label}</div>
          </div>
          <div className="contact-item-right d-flex flex-row align-items-center gap-2">
            {inputType === 'text' && 
            <DeleteIcon
              className="contact-item-icon"
              onClick={(event) => {
                event.stopPropagation();
                onDelete(network);
              }}
            />}

            <EditIcon className="contact-item-icon" />
            <div onClick={(event) => {
                event.stopPropagation(); // This stops the accordion from expanding/collapsing when the switch is toggled
              }} >
              <FormControlLabel
                className="me-0"
                control={
                  <Switch
                    defaultChecked
                    checked={visible}
                    onChange={(event) => {
                      toggleVisibility(network);
                      event.stopPropagation();
                    }}
                  />
                }
              />
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          {renderInputField()}
        </AccordionDetails>
        <AccordionActions className="px-3 d-flex gap-4">
          <Button className="secondary-btn" onClick={handleCancel}>Cancel</Button>
          <Button
            variant="contained"
            className="primary-btn"
            sx={{ boxShadow: "none" }}
            onClick={handleUpdate}
            disabled={isUpdateButtonEnabled}
          >
            Update
          </Button>
        </AccordionActions>
      </Accordion>
    );
  };

export default AccordionItem;

AccordionItem.propTypes = {
  inputType: PropTypes.oneOf(['text', 'email', 'phone']), // Add inputType prop
  handleResendOTP: PropTypes.func // Optional prop for contact details context
}

AccordionItem.defaultProps = {
    label: "Social Link",
    defaultOpen: false,
    inputType: 'text',
}